import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * The single page-title block used by every route.
 * Left: title + optional one-line description. Right: actions (one primary max).
 */
const PageHeader = ({ title, description, breadcrumbs, actions, children, className = '' }) => (
    <div className={`flex flex-wrap items-start justify-between gap-3 mb-5 ${className}`}>
        <div className="min-w-0">
            {breadcrumbs?.length > 0 && <Breadcrumbs items={breadcrumbs} />}
            <h1 className="text-2xl font-semibold text-ink-900 truncate">{title}</h1>
            {description && (
                <p className="text-md text-ink-600 mt-1 max-w-[75ch]">{description}</p>
            )}
            {children}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
);

export const Breadcrumbs = ({ items = [], className = '' }) => (
    <nav aria-label="Breadcrumb" className={`mb-1.5 ${className}`}>
        <ol className="flex items-center gap-1 text-label text-ink-500 flex-wrap">
            {items.map((item, i) => {
                const last = i === items.length - 1;
                return (
                    <li key={`${item.label}-${i}`} className="flex items-center gap-1">
                        {i > 0 && (
                            <ChevronRight size={12} className="text-ink-400" aria-hidden="true" />
                        )}
                        {item.to && !last ? (
                            <Link
                                to={item.to}
                                className="hover:text-primary-600 transition-colors duration-150"
                            >
                                {item.label}
                            </Link>
                        ) : (
                            <span aria-current={last ? 'page' : undefined} className={last ? 'text-ink-700' : ''}>
                                {item.label}
                            </span>
                        )}
                    </li>
                );
            })}
        </ol>
    </nav>
);

export default PageHeader;
